import React, { useState, useEffect } from "react"
import CallTableViewModel from "../../../ViewModels/CallTableViewModel"
import Grid from "@mui/material/Grid";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import AINoteFiltersViewModel from "./ViewModels/AINoteFiltersViewModel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";

interface IFiltersDialogProps {
    open: boolean
    setOpen: (value: boolean) => void
    callTableViewModel: CallTableViewModel
    setCallTableViewModel: (value: CallTableViewModel) => void
}

export default function AINoteFilterDialog(props: IFiltersDialogProps) {
    const [aiNoteFilter, setAINoteFilter] = useState<AINoteFiltersViewModel>(props.callTableViewModel.filters.aiNoteFilters);

    useEffect(() => {
        if (props.open) {
            setAINoteFilter(props.callTableViewModel.filters.aiNoteFilters);
        }
    }, [props.open])


    const Confirm = () => {
        const newCallTableViewModel = { ...props.callTableViewModel };

        newCallTableViewModel.filters.aiNoteFilters = aiNoteFilter;

        props.setCallTableViewModel({
            ...newCallTableViewModel
        })

        props.setOpen(false);
    }

    const handleNoteStateFilterChange = (e: any) => {
        setAINoteFilter({
            ...aiNoteFilter,
            noteState: e.target.value
        })
    }

    return (
        <Dialog
            open={props.open} onClose={() => props.setOpen(false)} fullWidth maxWidth="sm">
            <DialogTitle>
                AI Client Notes
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={1}>
                    <Grid size={12}>
                        <InputLabel>Status</InputLabel>
                        <Select
                            name='noteState'
                            onChange={handleNoteStateFilterChange}
                            value={aiNoteFilter.noteState}
                            fullWidth>
                            <MenuItem key={0} value="Not Available">Not Available</MenuItem>
                            <MenuItem key={1} value="Available And Not Actioned">Available And Not Actioned</MenuItem>
                            <MenuItem key={2} value="Available And Actioned">Available And Actioned</MenuItem>
                        </Select>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => props.setOpen(false)} color="primary">Cancel</Button>
                <Button onClick={Confirm} color="primary">Confirm</Button>
            </DialogActions>
        </Dialog>
    )
}